var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterXqLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 35,
    viewBox: "0 0 59 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XQ_LOGO_FIXED_V01BA_BLACK",
    clipPath: "url(#clip0_1184_51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer-MC0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1184_51",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 35
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M0 0H58.4319V35H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1184_51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M27.5298 8.82629C28.2097 8.1463 28.2097 7.0439 27.5298 6.36391C26.8498 5.6841 25.7474 5.68392 25.0674 6.36391L16.3781 15.0532L16.3345 15.0968L16.291 15.0532L7.60167 6.36391C6.92168 5.68392 5.81929 5.6841 5.1393 6.36391C4.45931 7.0439 4.45931 8.1463 5.1393 8.82629L13.8286 17.5156L13.8721 17.5591L5.1393 26.2918C4.45931 26.9718 4.45931 28.0744 5.1393 28.7544C5.4792 29.0943 5.92484 29.2642 6.37048 29.2642C6.81613 29.2642 7.26177 29.0943 7.60167 28.7544L16.3345 20.0215L25.0674 28.7544C25.4073 29.0943 25.8529 29.2642 26.2986 29.2642C26.7442 29.2642 27.1898 29.0943 27.5298 28.7544C28.2097 28.0744 28.2097 26.9718 27.5298 26.2918L18.7969 17.5591L18.8404 17.5156L27.5298 8.82629Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1184_51",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 35
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M-3.8147e-06 0H58.4319V35H-3.8147e-06V0Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1184_51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M48.7417 22.4946L45.1372 18.8901C44.4913 18.2443 43.4441 18.2443 42.798 18.8901C42.152 19.5361 42.152 20.5836 42.798 21.2295L46.4023 24.8338C44.9828 25.8023 43.2687 26.37 41.4243 26.37C36.5418 26.37 32.5696 22.398 32.5696 17.5157C32.5696 12.6334 36.5418 8.66116 41.4243 8.66116C46.3066 8.66116 50.2786 12.6334 50.2786 17.5157C50.2786 19.3604 49.7107 21.0748 48.7417 22.4946ZM51.233 24.9859C52.8173 22.9108 53.7609 20.3218 53.7609 17.5157C53.7609 10.7132 48.2267 5.17889 41.4243 5.17889C34.6216 5.17889 29.0873 10.7132 29.0873 17.5157C29.0873 24.3179 34.6216 29.8523 41.4243 29.8523C44.23 29.8523 46.8186 28.9088 48.8937 27.3251L50.5907 29.0221C50.9138 29.345 51.3369 29.5065 51.7602 29.5065C52.1837 29.5065 52.6069 29.345 52.93 29.0221C53.5759 28.3761 53.5759 27.3288 52.93 26.6828L51.233 24.9859Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1184_51",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 35
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M3.8147e-06 0H58.4319V35H3.8147e-06V0Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1184_51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M53.5356 24.6781C53.5261 24.6971 53.5119 24.7119 53.4926 24.7229C53.4734 24.7341 53.4497 24.7395 53.4217 24.7395H53.2488V24.4939H53.4217C53.4643 24.4939 53.4963 24.5054 53.5175 24.5284C53.5391 24.5515 53.5495 24.5809 53.5495 24.6168C53.5495 24.6389 53.545 24.6592 53.5356 24.6781ZM53.6458 24.8208C53.6372 24.8135 53.626 24.8102 53.6167 24.8041C53.6456 24.7895 53.6716 24.7721 53.6911 24.7492C53.7206 24.7147 53.7352 24.6704 53.7352 24.6168C53.7352 24.5612 53.7232 24.5122 53.6996 24.4693C53.6756 24.4269 53.6406 24.3934 53.5951 24.3695C53.5494 24.3459 53.4954 24.3338 53.433 24.3338H53.0541V25.23H53.2488V24.906H53.4217C53.4515 24.906 53.4767 24.9155 53.4972 24.9342C53.5175 24.953 53.5292 24.9777 53.5318 25.0085L53.5559 25.23H53.7493L53.725 24.9829C53.7182 24.9155 53.6919 24.8614 53.6458 24.8208Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1184_51",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 35
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M0 0H58.4319V35H0V0Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1184_51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M53.3749 25.4945C52.9826 25.4945 52.6638 25.1755 52.6638 24.7832C52.6638 24.3912 52.9826 24.0723 53.3749 24.0723C53.7671 24.0723 54.0861 24.3912 54.0861 24.7832C54.0861 25.1755 53.7671 25.4945 53.3749 25.4945ZM53.3749 23.8876C52.8811 23.8876 52.4792 24.2895 52.4792 24.7832C52.4792 25.2774 52.8811 25.6793 53.3749 25.6793C53.8688 25.6793 54.2707 25.2774 54.2707 24.7832C54.2707 24.2895 53.8688 23.8876 53.3749 23.8876Z",
    fill: "black"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1184_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.4319,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterXqLogo);
export default __webpack_public_path__ + "static/media/footer-xq-logo.c9b26ded3b35572837516f080309b6ac.svg";
export { ForwardRef as ReactComponent };